import { Stack } from '@mui/material';
import moment from 'moment';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { getFrequencyI18n } from '@woovi/shared';

import type { PaymentCheckoutPixAutomaticInfo_subscription$key } from './__generated__/PaymentCheckoutPixAutomaticInfo_subscription.graphql';
import { PixAutomaticInfoLabel } from '../pixAutomatic/PixAutomaticInfoLabel.tsx';

type PaymentCheckoutPixAutomaticInfoProps = {
  checkout: PaymentCheckoutPixAutomaticInfo_subscription$key;
};

export const PaymentCheckoutPixAutomaticInfo = (
  props: PaymentCheckoutPixAutomaticInfoProps,
): ReactNode => {
  const { t } = useTranslation();
  const checkout =
    useFragment<PaymentCheckoutPixAutomaticInfo_subscription$key>(
      graphql`
        fragment PaymentCheckoutPixAutomaticInfo_subscription on Checkout {
          title
          pixRecurringCheckoutOptions {
            frequency
            comment
            installmentCount
            dateStart
            dateEnd
          }
        }
      `,
      props.checkout,
    );

  return (
    <Stack gap={1} marginY={2}>
      <PixAutomaticInfoLabel
        title={t('Título')}
        content={checkout.title || '-'}
      />
      <PixAutomaticInfoLabel
        title={t('Description')}
        content={checkout.pixRecurringCheckoutOptions?.comment || '-'}
      />
      <PixAutomaticInfoLabel
        title={t('Frequency')}
        content={getFrequencyI18n({
          key: checkout.pixRecurringCheckoutOptions?.frequency as string,
          t,
        })}
      />
      <PixAutomaticInfoLabel
        title={t('Start date')}
        content={moment(checkout.pixRecurringCheckoutOptions?.dateStart).format(
          'DD/MM/YYYY',
        )}
      />
      {checkout.pixRecurringCheckoutOptions?.dateEnd && (
        <PixAutomaticInfoLabel
          title={t('End date')}
          content={moment(checkout.pixRecurringCheckoutOptions?.dateEnd).format(
            'DD/MM/YYYY',
          )}
        />
      )}
      {!checkout.pixRecurringCheckoutOptions?.dateEnd && (
        <PixAutomaticInfoLabel
          title={t('Installment count')}
          content={
            checkout.pixRecurringCheckoutOptions?.installmentCount
              ? checkout.pixRecurringCheckoutOptions?.installmentCount.toString()
              : t('Indeterminate')
          }
        />
      )}
    </Stack>
  );
};
